/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import personal from "../../assets/img/pcs/progress/vkh_icon_progressbar_person.png";
import income from "../../assets/img/pcs/progress/vkh_icon_progressbar_in.png";
import assets from "../../assets/img/pcs/progress/vkh_icon_progressbar_vermoegen.png";
import expenses from "../../assets/img/pcs/progress/vkh_icon_progressbar_out.png";

const progressBarsteps = [
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: personal,
  },
  {
    key: "income",
    name: "Einnahmen",
    icon: income,
  },
  {
    key: "assets",
    name: "Vermögen",
    icon: assets,
  },
  {
    key: "expenses",
    name: "Ausgaben",
    icon: expenses,
  },
];

export default progressBarsteps;
